module.exports = __webpack_public_path__ + "static/media/ribbon-specialoffer-en@3x.32b13638.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ribbon-specialoffer-en@3x.png
// module id = 315
// module chunks = 0